import {
  GET_MENU_LIST,
  GET_TITLE_LIST,
  GET_TENET_LIST,
  GET_VIDEO_LIST,
  GET_SODTODAY_LIST,
  GET_INDUSTRY_LIST,
  GET_INDPRODUCT_LIST,
  GET_PRODUCT_LIST,
  GET_TEAM_LIST,
  GET_ADVERT_LIST,
  GET_BUISNESS_LIST,
  GET_LIC_LIST,
  GET_PRESENTATION_LIST,
  GET_LEFTMENU_LIST,
  GET_SECTION_LIST,
  GET_CONTACT_LIST,
  GET_COMP_MENU_LIST,
  GET_COMPANY_CONTENT,
  GET_PRICE_TITLE
} from '../types/const.js';

export const  aGetContent = () => {
  return dispatch => {
    fetch('content.json')
      .then((response, reject) => {
        return response.json();
      })
      .then((jsonData) => {
        const menuList = [ ...jsonData.content.menu ];
        const titleList = [ ...jsonData.content.title ];
        const tenetList = jsonData.content.tenet;
        const videoList = jsonData.content.video;
        const sodtoday = jsonData.content.stoday;
        const industry = jsonData.content.industry;
        const indproduct = jsonData.content.indproduct;
        const product = jsonData.content.product;
        const team = jsonData.content.team;
        const advert = jsonData.content.advert;
        const buisness = jsonData.content.вusiness;
        const lic = jsonData.content.lic;
        const presentation = jsonData.content.presentation;
        const leftmenu = jsonData.content.leftmenu;
        const section = jsonData.content.section;
        const contact = jsonData.content.contact;
        const compmenu = jsonData.content.predmenu;
        const compcontent = jsonData.content.company;
        const titlePrice = jsonData.content.price;

        if (menuList !== undefined) { dispatch({ type:GET_MENU_LIST, amenuList: menuList });}
        if (titleList !== undefined) { dispatch({ type:GET_TITLE_LIST, atitleList: titleList });}
        if (tenetList !== undefined) { dispatch({ type:GET_TENET_LIST, atenetList: tenetList });}
        if (videoList !== undefined) { dispatch({ type:GET_VIDEO_LIST, avideoList: videoList });}
        if (sodtoday !== undefined) { dispatch({ type:GET_SODTODAY_LIST, asodtoday: sodtoday });}
        if (industry !== undefined) { dispatch({ type:GET_INDUSTRY_LIST, aindustry: industry });}
        if (indproduct !== undefined) { dispatch({ type:GET_INDPRODUCT_LIST, aindproduct: indproduct });}
        if (product !== undefined) { dispatch({ type: GET_PRODUCT_LIST, aproduct: product });}
        if (team !== undefined) {dispatch({ type: GET_TEAM_LIST, ateam: team });}
        if (advert !== undefined) {dispatch({ type:GET_ADVERT_LIST, aadvert: advert });}
        if (buisness !== undefined) {dispatch({ type:GET_BUISNESS_LIST, abuisness:buisness });}
        if (lic !== undefined) {dispatch({ type: GET_LIC_LIST, alic: lic });}
        if (presentation !== undefined) {dispatch({ type:GET_PRESENTATION_LIST, apresentation:presentation });}
        if (leftmenu !== undefined) {dispatch({ type:GET_LEFTMENU_LIST, aleftmenu:leftmenu });}
        if (section !== undefined) {dispatch({ type:GET_SECTION_LIST, asection:section });}
        if (contact !== undefined) {dispatch({ type:GET_CONTACT_LIST, acontact:contact });}
        if (compmenu !== undefined) {dispatch({ type:GET_COMP_MENU_LIST, acompmenu: compmenu });}
        if (compcontent !== undefined) {dispatch({ type:GET_COMPANY_CONTENT, acompcontent: compcontent });}
        if (titlePrice !== undefined) {dispatch({ type:GET_PRICE_TITLE, atitlePrice: titlePrice });}
      });
  };
};



// WEBPACK FOOTER //
// ./src/client/action/content.js